import { isValidEmail } from './validation'

const filled = v => typeof v === 'string' && v.trim() !== ''

export const authorizerComplete = application => {
	const a = application?.authorizer
	return !!a && filled(a.name) && filled(a.phone) && isValidEmail(a.email || '')
}

export const stakeholdersComplete = application => {
	const list = application?.stakeHolders || []
	return (
		list.length > 0 &&
		list.every(s => filled(s.name) && isValidEmail(s.email || ''))
	)
}

// Pisin vaihe (0-3), jolle käyttäjä saa siirtyä vaihe-esityksestä.
export const furthestReachablePage = application => {
	if (!authorizerComplete(application)) return 1
	if (!stakeholdersComplete(application)) return 2
	return 3
}

// Mitä maksusivulla puuttuu (tyhjä lista = valmis maksettavaksi).
export const missingForPayment = application => {
	const missing = []
	if (!authorizerComplete(application)) missing.push({ page: 1, label: 'Yhteystiedot' })
	if (!stakeholdersComplete(application))
		missing.push({ page: 2, label: 'Osakkeenomistajien tiedot' })
	return missing
}
